import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { LucideAngularModule } from "lucide-angular";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { NavigationElementComponent } from "../../domain/components/navigation-element/navigation-element.component";
import { LandingPageComponent } from "./landing-page.component";

const materialModules = [MatCardModule, MatButtonModule, MatIconModule];

@NgModule({
  declarations: [LandingPageComponent, NavigationElementComponent],
  providers: [],
  imports: [RouterModule, LucideAngularModule, CommonModule, CommonTranslateModule, BrowserAnimationsModule, ...materialModules],
})
export class LandingPageModule {}
